/**
 * @generated SignedSource<<3b211db1d3f75fe50a318e8f81789cb9>>
 * @relayHash 43d54ca288a673b02dda283e530d2603
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b90d6a1d6ed7a3cd6a9181b689700ee14f41bf49c21e3080a63fd98ed777861c

import type { ConcreteRequest } from 'relay-runtime';
export type CreateFromTemplateGetContentTypeQuery$variables = {
  contentId: string;
};
export type CreateFromTemplateGetContentTypeQuery$data = {
  readonly singleContent: {
    readonly id: string | null | undefined;
    readonly type: string | null | undefined;
  } | null | undefined;
};
export type CreateFromTemplateGetContentTypeQuery = {
  response: CreateFromTemplateGetContentTypeQuery$data;
  variables: CreateFromTemplateGetContentTypeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "type"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CreateFromTemplateGetContentTypeQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateFromTemplateGetContentTypeQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "43d54ca288a673b02dda283e530d2603",
    "id": "b90d6a1d6ed7a3cd6a9181b689700ee14f41bf49c21e3080a63fd98ed777861c",
    "metadata": {},
    "name": "CreateFromTemplateGetContentTypeQuery",
    "operationKind": "query",
    "text": "query CreateFromTemplateGetContentTypeQuery($contentId:ID!){singleContent(id:$contentId){id,type}}"
  }
};
})();

(node as any).hash = "74503a0f7f5b12c1389f8a393f9d456c";

export default node;
